import { motion, useInView } from "framer-motion";
import { useRef, useEffect, useState } from "react";

export const EASE = [0.76, 0, 0.24, 1];

// Reliable "in view" hook with a safety fallback so content is NEVER
// left permanently hidden if the IntersectionObserver misses (e.g. with
// smooth-scroll libraries or certain browsers).
function useReliableInView(amount = 0.25, fallbackMs = 900) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount });
  const [forced, setForced] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setForced(true), fallbackMs);
    return () => clearTimeout(t);
  }, [fallbackMs]);

  return [ref, inView || forced];
}

export function MaskedLine({ children, delay = 0, className = "", as: Tag = "span" }) {
  return (
    <Tag className={`mask-line ${className}`}>
      <motion.span
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, ease: EASE, delay }}
        style={{ display: "block" }}
      >
        {children}
      </motion.span>
    </Tag>
  );
}

export function MaskedLineReveal({ children, delay = 0, className = "" }) {
  const [ref, show] = useReliableInView(0.25);
  return (
    <span ref={ref} className={`mask-line ${className}`}>
      <motion.span
        initial={{ y: "110%" }}
        animate={{ y: show ? "0%" : "110%" }}
        transition={{ duration: 1.05, ease: EASE, delay }}
        style={{ display: "block" }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function FadeUp({ children, delay = 0, y = 40, className = "" }) {
  const [ref, show] = useReliableInView(0.2);
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={show ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
